"use client";

import { useAccountName } from "logic/hooks";

export function WelcomeTitle() {
  const name = useAccountName();

  // Unreachable in practice — the page gates on a connected address before
  // rendering this — but a "Welcome," with nothing after it is worth ruling out.
  if (!name) return null;

  return (
    <h1 className="text-display-sm-400 text-surface-on-surface">
      Welcome, <span className="text-ref-teal-600">{name}</span>
    </h1>
  );
}
